import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';

const StudentSchedule = () => {
    const { studentId } = useParams();
    const [events, setEvents] = useState([]);
    const [student, setStudent] = useState(null);
    const [holidays, setHolidays] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch both schedule and holidays
        Promise.all([
            axios.get(`/students/api/schedule/${studentId}/`),
            axios.get('/schedules/api/holidays/')
        ])
            .then(([scheduleResponse, holidaysResponse]) => {
                setHolidays(holidaysResponse.data);
                const response = scheduleResponse;
                const studentData = response.data.student;
                const scheduleData = response.data.schedule;

                // Helper function to check if a date falls within any holiday period
                const isDateInHoliday = (date) => {
                    return holidaysResponse.data.some(holiday => {
                        const holidayStart = new Date(holiday.start_date);
                        const holidayEnd = new Date(holiday.end_date);
                        return date >= holidayStart && date <= holidayEnd;
                    });
                };

                // Map schedule data to recurring events (without holiday exclusions for now)
                const calendarEvents = scheduleData.map(period => {
                    return {
                        title: `${period.teacher || ''} - ${period.group || ''}`, // Show teacher first
                        startTime: period.start_time,
                        endTime: period.end_time,
                        daysOfWeek: period.days_of_week.map(day => {
                            const dayMapping = {
                                Monday: 1,
                                Tuesday: 2,
                                Wednesday: 3,
                                Thursday: 4,
                            };
                            return dayMapping[day];
                        }),
                        startRecur: period.block_start, // Block start from backend
                        endRecur: period.block_end,   // Block end from backend
                        classNames: ['class-event'] // Add CSS class for styling
                    };
                });

                // Add holiday events as all-day background events
                const holidayEvents = holidaysResponse.data.map(holiday => {
                    return {
                        title: holiday.name,
                        start: holiday.start_date,
                        end: holiday.end_date,
                        allDay: true,
                        display: 'background',
                        backgroundColor: '#ffebee',
                        borderColor: '#f44336',
                        classNames: ['holiday-event']
                    };
                });

                // Combine class events and holiday events
                const allEvents = [...calendarEvents, ...holidayEvents];

                setStudent(studentData);
                setEvents(allEvents);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching student schedule:', error);
                setLoading(false);
            });
    }, [studentId]);

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="schedule-container">
            <h2>Schedule for {student?.name}</h2>
            <FullCalendar
                plugins={[timeGridPlugin]}
                initialView="timeGridWeek"
                events={events}
                slotMinTime="07:00:00"
                slotMaxTime="18:00:00"
                allDaySlot={true}
                height="auto" // Adjust height dynamically
                contentHeight="auto" // Ensure dynamic sizing
                expandRows={true} // Prevent rows from collapsing
                headerToolbar={{
                    start: 'title',
                    center: '',
                    end: 'today prev,next',
                }}
                eventContent={renderEventContent} // Render event content
            />
        </div>
    );
};

// Custom event rendering to ensure teacher appears prominently
const renderEventContent = (eventInfo) => {
    const [teacher, group] = eventInfo.event.title.split(' - '); // Split title into teacher and group
    return (
        <div style={{ fontSize: '14px' }}>
            <strong>{teacher}</strong> <br /> {/* Teacher's name */}
            <span>{group}</span> {/* Group name */}
        </div>
    );
};

export default StudentSchedule;
